import { getApiConfig } from '../config';
import { MemoryImageCache } from '../services';
import { createUserServiceClient } from './apiClientFactory';

export const getUserAvatarFromCache = async (userId: string): Promise<{ base64Avatar: string | undefined }> => {
  const cachedAvatar = MemoryImageCache.get(userId);
  if (cachedAvatar) {
    return cachedAvatar;
  }

  const userServiceClient = createUserServiceClient();
  const result = await userServiceClient.getOtherUsersBase64Avatar(userId);

  if (result.base64Avatar) {
    MemoryImageCache.add(userId, result.base64Avatar);
  }
  return result;
};

export function getInfluencerAvatarURL(userId: string): string {
  const baseUrlForImage = getApiConfig().INFlUENCER_BASE_URL;
  return `${baseUrlForImage}/${userId}/avatar`;
}
